import type {
    GetMarkets_markets_edges_node as Market,
    GetProductsCategories_productCategories as ProductCategory,
} from 'nutshell-graphql-types';

import type {DromoField, BulkRowHook} from '../types';

import {
    GENERAL_DROMO_FIELDS,
    NUMBER,
    MIN_NUMBER_VALUE,
    PRODUCT_TYPE_GOOD,
    CATEGORY_ID_KEY,
} from './consts';

// Appends a price field for each market in addition to the general fields.
export function generateDromoProductFields(markets: Market[]): Array<DromoField> {
    if (!markets) {
        return [];
    }

    return [
        // @ts-expect-error
        ...GENERAL_DROMO_FIELDS,
        ...markets.map((market) => ({
            label: `${market.name || ''} (${market.currency || ''})`,
            key: market.id,
            type: [NUMBER, {min: MIN_NUMBER_VALUE}],
            alternateMatches: [market.name, market.currencySymbol, market.currency],
        })),
    ];
}

// Dromo will run this after user uploads the file, or if the user manually
// updates the data. It will remove the Term value if the product type is Good.
export function getDromoProductBulkRowHooks(): Array<BulkRowHook> {
    return [
        (record) => {
            // @ts-expect-error
            return record.map((row) => {
                if (!row || !row.row) {
                    return row;
                }

                const newRow = row;
                if (newRow.row.type.resultValue === PRODUCT_TYPE_GOOD && newRow.row.unit.value) {
                    newRow.row.unit.value = null;
                }

                return newRow;
            });
        },
    ];
}

export function getDromoProductCategorySelectField(
    productCategories: Array<ProductCategory>
): DromoField | null | undefined {
    return {
        label: 'Category',
        key: CATEGORY_ID_KEY,
        type: 'select',
        selectOptions: productCategories.map((category) => ({
            label: category.name,
            value: category.id,
        })),
    };
}
